import { goOrangeAxios } from './axios';


export async function getCustomerTypeWithStatus(tspId) {
    return goOrangeAxios.get(`/v1/mydriver-supply/tsp/${tspId}/get-type`);
}
